import { Form, Header, Overlay, Page, Tab, TabHeader, TabLink } from "../manage/styles";
// import FormInput from "../../input";
import { GetValue } from "../functions";
import { GetIcon } from "../../../../icons";
import { CloseButton, CommentBox, CommentHeader, CommentText, DataHead, DataItem, FileCategory, FileTitle, Head, Profile, TabContainer, TabHead, TabItems, TabList, TabText, Td, Title, TrBody } from "./styles";
import Tabs from "../../tab";
import React, { useCallback, useEffect, useState } from "react";
import { ColumnContainer, RowContainer } from "../../../styles/containers/styles";
import ListTable from "../list";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import FormInput from "../../input";
import { getData, postData, putData } from "../../../../backend/api";
import { Button } from "../../drawer/style";
import { Footer } from "../create/styles";
import ViewFiles from "../../../private/pages/documents/ViewFiles";
import { useNavigate, useSearchParams } from "react-router-dom";
import { InputContainer, TextArea } from "../../input/styles";
import { generateThumbnail } from "../../../functions/string";
import { ProfileIcon } from "../../../private/common/layout/styels";
export const DisplayInformations = ({ udpateView, isEditingHandler, customClass, profileImage, attributes, data, formMode, formView, setMessage, setLoaderBox, actions, refresh = () => {},tabName="generalInfo" ,display,api,viewDetails}) => {
  const [currentData, setCurrentData] = useState(data??false);
  const [newComment, setNewComment] = useState("");
  const user = useSelector((state) => state.login)
  const dispatch = useDispatch();
    const navigate = useNavigate();

  const sendInvitation = (user) => {
    setLoaderBox(true);
    postData({ user }, "user/send-invitation", dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 200 });
          setCurrentData((prevCurrentData) => ({
            ...prevCurrentData,
            invitationSent: true,
          }));
          refresh();
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        setLoaderBox(false);
      });
  };
  const [t] = useTranslation();
  const { i18n } = useTranslation();
  const [selectedLanguage] = useState(i18n.language || "de");
  const [groupedTabs] = useState(() => {
    const groupedTabsTemp =
      formView === "tabs"
        ? attributes?.length > 0 &&
          attributes.reduce((result, attribute, index) => {
            const tabName = attribute.tab;
            const existingTab = result.find((tab) => tab.tabName === tabName);
            const attributeTemp = { ...attribute, index };
            if (attribute.view || (attribute.tag ?? false)) {
              if (existingTab) {
                existingTab.tabItems.push(attributeTemp);
              } else {
                result.push({ tabName, tabItems: [attributeTemp] });
              }
            }
            return result;
          }, [])
        : [];

    // Rearrange tabItems within each tab group
    // if(window.innerWidth > 768){
    //   groupedTabsTemp.forEach((tabGroup) => {
    //     const data1 = [];

    //     let i = 0;
    //     let count = Math.ceil(tabGroup.tabItems.length / 2); // Corrected to use Math.ceil
    //     while (count > i) {
    //       data1.push(tabGroup.tabItems[i]);
    //       if (i + count < tabGroup.tabItems.length) {
    //         data1.push(tabGroup.tabItems[i + count]);
    //       }
    //       i++;
    //     }
    //     tabGroup.tabItems = data1;
    //   });
    // }

    return groupedTabsTemp;
  });
  const [noGroups, setNoGroups] = useState(() => {
    console.log(formView,attributes);
    let tabItems = formView !== "tabs" ? attributes?.length > 0 && attributes.filter((attribute) => attribute.view || (attribute.tag ?? false)) : [];

    // // Rearrange tabItems within each tab group

    const data1 = [];

    // let i = 0;
    // let count = Math.ceil(tabItems.length / 2);
    // while (count > i) {
    //   data1.push(tabItems[i]);
    //   if (i + count < tabItems.length) {
    //     data1.push(tabItems[i + count]);
    //   }
    //   i++;
    // }
    // tabItems = data1;

    return tabItems; // Return the modified tabItems as the initial state
  });

  const addSeenNews = async(data)=>{
    console.log(data);
    let payloadData = { news: data._id};
    await postData(payloadData, "readStatus", dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {

          // udpateView(0);
        } else if (response.status === 404) {
          // setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
        } else {
          // setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
        }
        // setLoaderBox(false);
      })
      .catch((error) => {
        // setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay" });
        // setLoaderBox(false);
      });
  }

  useEffect(() => {
    const fetc = ()=> {
      let tabItems = formView !== "tabs" ? attributes?.length > 0 && attributes.filter((attribute) => attribute.view || (attribute.tag ?? false)) : [];

    // Rearrange tabItems within each tab group

    const data1 = [];

    // let i = 0;
    // let count = Math.ceil(tabItems.length / 2);
    // while (count > i) {
    //   data1.push(tabItems[i]);
    //   if (i + count < tabItems.length) {
    //     data1.push(tabItems[i + count]);
    //   }
    //   i++;
    // }
    // tabItems = data1;

    return tabItems;
    }
    if(attributes){
      console.log(attributes[0].tab);
      tabName = attributes[0].tab ?? tabName;
      setNoGroups(fetc())
    }
  }, [attributes])

  useEffect(() => {
    if(data){
      setCurrentData(data);
      if(api==="news"){
        addSeenNews(data)
      }
      if(api==="whistleblowing"){
        getComments(data)
      }
    }
  }, [data])
  

  const objectValueReturn = (data, attribute) => {
    if (attribute.showItem && data[attribute.name]?.[attribute.showItem]) {
      return data[attribute.name][attribute.showItem];
    } 
    else if(attribute.showItem==="locale" && data[attribute.name]){
      return data[attribute.name][localStorage.getItem("_lang") ?? "de"];
    }
    else if (!attribute.showItem && data[attribute.name]) {
      // Check if the key of data matches specific known keys
      if (["countryOfBirth", "country", "nationality", "workDays", "religion"].includes(attribute.name)) {
        return data[attribute.name][localStorage.getItem("_lang") ?? "de"];
      } 
      else if (attribute.name === "company") {
        return data[attribute.name]?.organization;
      } 
      else if (attribute.name === "terminationBy") {
        return data[attribute.name]?.name;
      } 
      else {
        return data[attribute.name]?.title ?? "Nil";
      }
    } 
    else {
      return "Nil";
    }
  };
  const [searchParams] = useSearchParams();
  const paramValue = searchParams.get('tab');

  const hasTabs = actions?.some((item) => item.type === "subList" && item.element === "button") ?? false;
  const hasFiles = actions?.some((item) => item.id === "generatePdf" && item.element === "callback") ?? false;
  //theme colors
  const themeColors = useSelector((state) => state.themeColors);
  const [activeTab, setActiveTab] = useState(formView === "tabs" ? (paramValue ? paramValue : (groupedTabs?.length > 0 ? groupedTabs[0].tabName : "generalInfo")) : tabName);
  const profileImageLink = profileImage?.length > 2 && currentData["photo"] ? process.env.REACT_APP_CDN.toString() + currentData["photo"]?.toString() : `${process.env.REACT_APP_CDN.toString()}uploads/profile/profile.jpg`;

  useEffect(() => {
    if (formView === "tabs") {
      setActiveTab(paramValue ? paramValue : (groupedTabs?.length > 0 ? groupedTabs[0].tabName : "generalInfo"));
    }
  }, [window.location.pathname, paramValue]);

  const getComments = async (data)=>{
    try {
      let payloadData = { whistleblowingId: data._id};
      await getData(payloadData, "whistleblowing-comment", dispatch, navigate)
        .then((response) => {
          if (response.status === 200) {
            setCurrentData({...currentData, comments: response.data.data})
            // udpateView(0);
          } else if (response.status === 404) {
            // setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
          } else {
            // setMessage({ type: 1, content: t(response.data), proceed: "Okay" });
          }
          // setLoaderBox(false);
        })
        .catch((error) => {
          // setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay" });
          // setLoaderBox(false);
        });
    } catch (error) {
      
    }
  }

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    if (newComment.trim()) {
    let current = {...currentData};
    
    // setCurrentData(current);
    let payload = {
      user: user?.data?.user?._id,
      comment: newComment,
      whistleblowingId: currentData._id
    }
    
    await postData(payload, `whistleblowing-comment`, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          let res = {...response.data.data}
          res.user = user.data?.user
          current.comments = [...(current.comments || []), res];
          setCurrentData(current);
          setNewComment("");
          // udpateView(0);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        // setLoaderBox(false);
      })
      .catch((error) => {
        // setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay" });
        // setLoaderBox(false);
      });
    }
  }

  const [docsCategory, setDocsCategory] = useState([]);
  const [selectedDocsCategory, setSelectedDocsCategory] = useState("");

  const docType = async()=>{
    try {
      await getData({}, `files/type/${currentData._id}`, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          setDocsCategory(response.data.data);
          setSelectedDocsCategory(response.data.data[0]?._id);
          // udpateView(0);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        // setLoaderBox(false);
      })
      .catch((error) => {
        // setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay" });
        // setLoaderBox(false);
      });
    
    } catch (error) {
      
    }
  }

  useEffect(() => {
    if(actions?.filter(action => action.title === "files").length > 0 && currentData._id){
      docType()
    }
  }, [actions,currentData])
  
  return (
    <TrBody className={`${formView === "tabs" ? "" : formMode} ${customClass ?? ""}`}>
      {formView === "tabs" ? (
        <TabContainer className="vertical">
          <TabHeader className="vertical mh">
            {profileImage && <Profile className={`${currentData.photo ? "photo" : ""}`}>
              <ProfileIcon className={`${currentData.photo ? "photo" : ""}`} style={{margin:'10px 0'}}>{generateThumbnail(currentData?.fullName ?? "", null, currentData.photo ?? "", "profile")}</ProfileIcon>
              <h6>{`${currentData["firstName"]} ${currentData["lastName"]}`}</h6>
              <ColumnContainer className="buttons">
                {isEditingHandler && (
                  <button onClick={() => isEditingHandler(currentData, udpateView)}>
                    <GetIcon icon={"edit"}></GetIcon>
                  </button>
                )}
                {isEditingHandler && currentData.mobileNumber && (
                  <button onClick={() => (window.location.href = `tel:${currentData.mobileNumber}`)}>
                    <GetIcon icon={"call"}></GetIcon>
                  </button>
                )}
              </ColumnContainer>
            </Profile>}
            <TabList>
              {groupedTabs.map((group) => {
                if(group.tabName==="official"){
                  let item = actions?.find((val) => val.type === "subList" && val.element === "button" && val?.title==="salary")
                  return (
                    <>
                  <React.Fragment key={group.tabName}>
                    <TabLink
                      key={`main-` + group.tabName}
                      theme={themeColors}
                      className={activeTab === group.tabName && "active"}
                      onClick={() => {
                        setActiveTab(group.tabName);
                      }}
                    >
                      <TabText> {t(group.tabName)}</TabText>
                    </TabLink>
                  </React.Fragment>
                  {item &&<TabLink
                  key={`main-` + item?.title}
                  theme={themeColors}
                  className={activeTab === item?.title && "active"}
                  onClick={() => {
                    setActiveTab(item?.title);
                  }}
                >
                  <TabText> {t(item?.title)}</TabText>
                </TabLink>}
                </>
                  )
                }
                else{
                return <React.Fragment key={group.tabName}>
                  {group.tabItems?.length > 0 && (
                    <TabLink
                      key={`main-` + group.tabName}
                      theme={themeColors}
                      className={activeTab === group.tabName && "active"}
                      onClick={() => {
                        setActiveTab(group.tabName);
                      }}
                    >
                      <TabText> {t(group.tabName)}</TabText>
                    </TabLink>
                  )}
                </React.Fragment>
                }
              })}
              {actions?.map((item) => {
                return (
                  item.type === "subList" &&
                  item.element === "button" && item?.title!=="salary" && (
                    <TabLink
                      key={`main-` + item?.title}
                      theme={themeColors}
                      className={activeTab === item?.title && "active"}
                      onClick={() => {
                        setActiveTab(item?.title);
                      }}
                    >
                      <TabText> {t(item?.title)}</TabText>
                    </TabLink>
                  )
                );
              })}
            </TabList>
          </TabHeader>
          <TabItems>
            {groupedTabs.map((group) => {
              if(group.tabName==="official"){
                let item = actions?.find((val) => val.type === "subList" && val.element === "button" && val?.title==="salary")
                const groupedData = [];
let currentGroup = null;

// Step 1: Group the items by title
group.tabItems.forEach(item => {
  if (item.type === 'title') {
    currentGroup = { title: item.title, fields: [item] };
    groupedData.push(currentGroup);
  } else if (currentGroup) {
    currentGroup.fields.push(item);
  }
});

// Step 2: Initialize left and right with first and last groups
const left = [], right = [];
let leftFieldCount = 0, rightFieldCount = 0;

if (groupedData.length > 0) {
  const firstGroup = groupedData.shift(); // removes and returns first
  left.push(firstGroup);
  leftFieldCount += firstGroup.fields.length;
}

if (groupedData.length > 0) {
  const lastGroup = groupedData.pop(); // removes and returns last
  right.push(lastGroup);
  rightFieldCount += lastGroup.fields.length;
}

// Step 3: Distribute remaining groups based on field count
groupedData.forEach(group => {
  const fieldCount = group.fields.length;
  if (leftFieldCount <= rightFieldCount) {
    left.push(group);
    leftFieldCount += fieldCount;
  } else {
    right.push(group);
    rightFieldCount += fieldCount;
  }
});

              // console.log(left, right, leftCount, rightCount);
                return (<>
                  <Tab className="sub" key={`sub-${group.tabName}`} active={activeTab === group.tabName}>
                {api!=="news" && <TabHead>{t(group.tabName)}</TabHead>}
                <Form className={`vertical sub ${formMode}`}>
                {console.log(group.tabName , group.tabItems)}
                <div>
                  {left.length > 0 && left.map((leftData, index) => (
                  leftData.fields?.length > 0 &&
                  leftData.fields.map((attribute, index) => {
                      if (attribute.view || (attribute.tag ?? false)) {
                        try {
                          let itemValue;
                          if (attribute.type === "expired" && attribute.showItem === "contractEnd") {
                            if (data.contractEnd === null && data.contractFrom !== null) {
                                itemValue = new Date(data.contractFrom) <= new Date() ? new Date(new Date().setDate(new Date().getDate() + 1)) : null;
                            } else if (data.contractEnd === null && data.contractFrom === null) {
                                itemValue = new Date(new Date().setDate(new Date().getDate() + 1));
                            } else {
                              itemValue = new Date(data.contractEnd) >= new Date() ? new Date(data.contractEnd) : null;
                            }
                          } else if (attribute.collection?.length > 0 && attribute.showItem?.length > 0) {
                            itemValue = data[attribute.collection]?.[attribute.showItem];
                          } else {
                            itemValue = data[attribute.name];
                          }
                          if (attribute.type === "select" && attribute?.showItem === "locale") {
                            itemValue = attribute.showItem?.length > 0 ? currentData[attribute.name][selectedLanguage] : currentData[attribute.name];
                          }
                          if (attribute.type === "invitation") {
                            return (
                              <Td key={index}>
                                <Title>{t(attribute.label)}</Title>
                                <DataItem>
                                  {currentData["invitationSent"] ?? false ? (
                                    <>
                                      <FormInput
                                        onChange={() => {
                                          sendInvitation(currentData["_id"]);
                                        }}
                                        type="submit"
                                        value={t("resendInvitation")}
                                        disabled={currentData["email"] ? false : true}
                                      ></FormInput>
                                    </>
                                  ) : (
                                    <FormInput
                                      onChange={() => {
                                        sendInvitation(currentData["_id"]);
                                      }}
                                      type="submit"
                                      value={t("sendInvitation")}
                                      disabled={currentData["email"] ? false : true}
                                    ></FormInput>
                                    
                                  )}
                                </DataItem>
                              </Td>
                            );
                          }
                          if (attribute.type === "title") {
                            return (
                              <Td className="bold" key={index}>
                                <Title className="bold">{t(attribute.title)}</Title>
                              </Td>
                            );
                          }
                          return (
                            <Td key={index}>
                              <Title>{t(attribute.label)}</Title>
                              <DataItem>{GetValue(attribute, itemValue, true)}{(attribute.name==="hoursAtLeast" || attribute.name === "hoursMaximum" || attribute.name === "hoursTarget")&&(" "+ t("Hours"))}</DataItem>
                            </Td>
                          );
                        } catch (error) {
                          return (
                            <Td key={index}>
                              <Title>{t(attribute.label)}</Title>
                              <DataItem>--</DataItem>
                            </Td>
                          );
                        }
                      }

                      return null; // Return null if the condition is not met, to avoid rendering unwanted elements
                    })))}
                    </div>
                <div>
                {right.length > 0 && right.map((leftData, index) => (
                  leftData.fields?.length > 0 &&
                  leftData.fields.map((attribute, index) => {
                      if (attribute.view || (attribute.tag ?? false)) {
                        try {
                          let itemValue;
                          if (attribute.type === "expired" && attribute.showItem === "contractEnd") {
                            if (data.contractEnd === null && data.contractFrom !== null) {
                                itemValue = new Date(data.contractFrom) <= new Date() ? new Date(new Date().setDate(new Date().getDate() + 1)) : null;
                            } else if (data.contractEnd === null && data.contractFrom === null) {
                                itemValue = new Date(new Date().setDate(new Date().getDate() + 1));
                            } else {
                              itemValue = new Date(data.contractEnd) >= new Date() ? new Date(data.contractEnd) : null;
                            }
                          } else if (attribute.collection?.length > 0 && attribute.showItem?.length > 0) {
                            itemValue = data[attribute.collection]?.[attribute.showItem];
                          } else {
                            itemValue = data[attribute.name];
                          }
                          if (attribute.type === "select" && attribute?.showItem === "locale") {
                            itemValue = attribute.showItem?.length > 0 ? currentData[attribute.name][selectedLanguage] : currentData[attribute.name];
                          }
                          if (attribute.type === "invitation") {
                            return (
                              <Td key={index}>
                                <Title>{t(attribute.label)}</Title>
                                <DataItem>
                                  {currentData["invitationSent"] ?? false ? (
                                    <>
                                      <FormInput
                                        onChange={() => {
                                          sendInvitation(currentData["_id"]);
                                        }}
                                        type="submit"
                                        value={t("resendInvitation")}
                                        disabled={currentData["email"] ? false : true}
                                      ></FormInput>
                                    </>
                                  ) : (
                                    <FormInput
                                      onChange={() => {
                                        sendInvitation(currentData["_id"]);
                                      }}
                                      type="submit"
                                      value={t("sendInvitation")}
                                      disabled={currentData["email"] ? false : true}
                                    ></FormInput>
                                    
                                  )}
                                </DataItem>
                              </Td>
                            );
                          }
                          if (attribute.type === "title") {
                            return (
                              <Td className="bold" key={index}>
                                <Title className="bold">{t(attribute.title)}</Title>
                              </Td>
                            );
                          }
                          return (
                            <Td key={index}>
                              <Title>{t(attribute.label)}</Title>
                              <DataItem>{GetValue(attribute, itemValue, true)}{(attribute.name==="hoursAtLeast" || attribute.name === "hoursMaximum" || attribute.name === "hoursTarget")&&(" "+ t("Hours"))}</DataItem>
                            </Td>
                          );
                        } catch (error) {
                          return (
                            <Td key={index}>
                              <Title>{t(attribute.label)}</Title>
                              <DataItem>--</DataItem>
                            </Td>
                          );
                        }
                      }

                      return null; // Return null if the condition is not met, to avoid rendering unwanted elements
                    })))}
                    </div>
                </Form>
                  </Tab>
                  {item && currentData && currentData?._id && <Tab className="sub" key={`sub-${item?.title}`} active={activeTab === item?.title}>
                    <ListTable setMessage={setMessage} setLoaderBox={setLoaderBox} referenceId={currentData?._id} attributes={item?.attributes} {...item.params} shortName={item?.title} listHeadClass={"static"} viewDetails={viewDetails}></ListTable>
                  </Tab>}
              </>)
              }
              else{
                return <Tab className="sub" key={`sub-${group.tabName}`} active={activeTab === group.tabName}>
                {api!=="news" && <TabHead>{t(group.tabName)}</TabHead>}
                <Form className={`vertical sub ${formMode}`}>
                  {group.tabItems?.length > 0 &&
                    group.tabItems.map((attribute, index) => {
                      if(!(currentData.companyRoster) && (attribute.name==="timeRecordWithoutRoaster" || attribute.name==="timeRecordWithShiftRoaster"))
                        return null;
                      if (attribute.view || (attribute.tag ?? false)) {
                        try {
                          let itemValue;
                          if (attribute.type === "expired" && attribute.showItem === "contractEnd") {
                            if (data.contractEnd === null && data.contractFrom !== null) {
                                itemValue = new Date(data.contractFrom) <= new Date() ? new Date(new Date().setDate(new Date().getDate() + 1)) : null;
                            } else if (data.contractEnd === null && data.contractFrom === null) {
                                itemValue = new Date(new Date().setDate(new Date().getDate() + 1));
                            } else {
                              itemValue = new Date(data.contractEnd) >= new Date() ? new Date(data.contractEnd) : null;
                            }
                          } else if (attribute.collection?.length > 0 && attribute.showItem?.length > 0) {
                            itemValue = data[attribute.collection]?.[attribute.showItem];
                          } else {
                            itemValue = data[attribute.name];
                          }
                          if (attribute.type === "select" && attribute?.showItem === "locale") {
                            itemValue = attribute.showItem?.length > 0 ? currentData[attribute.name][selectedLanguage] : currentData[attribute.name];
                          }
                          if (attribute.type === "invitation") {
                            return (
                              <Td key={index}>
                                <Title>{t(attribute.label)}</Title>
                                <DataItem>
                                  {currentData["invitationSent"] ?? false ? (
                                    <>
                                      <FormInput
                                        onChange={() => {
                                          sendInvitation(currentData["_id"]);
                                        }}
                                        type="submit"
                                        value={t("resendInvitation")}
                                        disabled={currentData["email"] ? false : true}
                                      ></FormInput>
                                    </>
                                  ) : (
                                    <FormInput
                                      onChange={() => {
                                        sendInvitation(currentData["_id"]);
                                      }}
                                      type="submit"
                                      value={t("sendInvitation")}
                                      disabled={currentData["email"] ? false : true}
                                    ></FormInput>
                                  )}
                                </DataItem>
                              </Td>
                            );
                          }
                          if (attribute.type === "title") {
                            return (
                              <Td className="bold" key={index}>
                                <Title className="bold">{t(attribute.title)}</Title>
                              </Td>
                            );
                          }
                          return (
                            <Td key={index}>
                              <Title>{t(attribute.label)}</Title>
                              <DataItem>{GetValue(attribute, itemValue, true)}{(attribute.name==="hoursAtLeast" || attribute.name === "hoursMaximum" || attribute.name === "hoursTarget")&&(" "+ t("Hours"))}</DataItem>
                            </Td>
                          );
                        } catch (error) {
                          return (
                            <Td key={index}>
                              <Title>{t(attribute.label)}</Title>
                              <DataItem>--</DataItem>
                            </Td>
                          );
                        }
                      }

                      return null; // Return null if the condition is not met, to avoid rendering unwanted elements
                    })}
                </Form>
                {group.tabName==="details" && <div style={{position:'relative'}}>
                    <p style={{fontSize:'18px', fontWeight:'bold'}}>{"Whistleblowing "+t("comments")}</p>
                  {/* <div style={{margin:"0 30px",marginBottom:"170px", overflowY:'auto', maxHeight:'300px'}}> */}
                  <div style={{margin:"0 30px"}}>
                {Array.isArray(currentData?.comments) && currentData?.comments?.map((item,index) => (
                  <div key={index} style={{display:'flex', justifyContent: (item.user && item.user._id===user?.data?.user?._id) ? 'flex-end' : 'flex-start'}}>
                  <CommentBox >
                    <CommentHeader>
                      {(item.user && item.user._id===user?.data?.user?._id) ? t("you") : item?.user?.fullName ? item?.user?.fullName : t("Unknown Employee")} - {item.createdAt && new Date(item.createdAt).toLocaleString("de-DE", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                      })}
                    </CommentHeader>
                    <CommentText>{item?.comment}</CommentText>
                  </CommentBox>
                  </div>
                ))}
                </div>
                {/* <Form style={{position:"absolute", bottom: 0, left: 0, right: 0}} className={`vertical sub ${formMode}`}> */}
                <Form  className={`vertical sub ${formMode}`}>
                  <InputContainer>
                    <TextArea style={{margin:"10px 30px", width:'auto', fontSize:'16px'}} theme={themeColors} className={`input`} placeholder={`${t("addAComment")}`} value={newComment} onChange={(e) => setNewComment(e.target.value)} />
                  </InputContainer>
                  <Button onClick={handleCommentSubmit} style={{margin:"10px 30px", width:'auto',fontSize:"17px", fontWeight:"600"}}>{t("Add Comment")}</Button>
                </Form>
                </div>}
                </Tab>
              }
            })}
            {currentData && currentData?._id && actions?.map((item) => {
              return (
                item.type === "subList" &&
                item.element === "button" && item?.title!=="salary" && (
                  <Tab className={`sub ${item.title}`} key={`sub-${item?.title}`} active={activeTab === item?.title}>
                    {item.title==="files" && <FileCategory>
                      <FileTitle>{t("category")}</FileTitle>
                      <div style={{borderBottom:'2px solid #d6e0ff', marginBottom:'10px'}}></div>
                        {Array.isArray(docsCategory) && docsCategory?.map((val,idx) => (
                          <TabLink
                        key={`docs-type-` + idx}
                        theme={themeColors}
                        className={`${selectedDocsCategory === val?._id && "active"} files `}
                        onClick={() => {
                          setSelectedDocsCategory(val?._id);
                        }}
                      >
                        <TabText> {t(localStorage.getItem("_lang") ? val?.[localStorage.getItem("_lang")] : val?.de ? val?.de : val?.en)}</TabText>
                        <TabText className={`fileCount ${selectedDocsCategory === val?._id && "active"}`} >{val?.fileCount}</TabText>
                      </TabLink>
                        ))}
                        
                    </FileCategory>}
                    <ListTable setMessage={setMessage} setLoaderBox={setLoaderBox} referenceId={currentData?._id} attributes={item.attributes} {...item.params} shortName={item?.title} listHeadClass={"static"} viewDetails={viewDetails} selectedDocsCategory={item.title==="files" && selectedDocsCategory} ></ListTable>
                  </Tab>
                )
              );
            })}
          </TabItems>
        </TabContainer>
      ) : (
        <TabContainer className={`vertical ${hasFiles ? "files":""}`}>
          {hasTabs && (
            <TabHeader className="vertical mh">
              <TabList>
                <TabLink
                  key={`main-generalInfo`}
                  theme={themeColors}
                  className={activeTab === tabName && "active"}
                  onClick={() => {
                    setActiveTab(tabName);
                  }}
                >
                  <TabText> {t(tabName)}</TabText>
                </TabLink>
                {actions?.map((item) => {
                  return (
                    item.type === "subList" &&
                    item.element === "button" && (
                      <TabLink
                        key={`main-` + item?.title}
                        theme={themeColors}
                        className={activeTab === item?.title && "active"}
                        onClick={() => {
                          setActiveTab(item?.title);
                        }}
                      >
                        <TabText> {t(item?.title)}</TabText>
                      </TabLink>
                    )
                  );
                })}
              </TabList>
            </TabHeader>
          )}
          <TabItems className={`${hasTabs}`}>
            <Tab className={`sub ${hasTabs}`} key={`sub-generalInfo`} active={activeTab === tabName}>
              <TabHead className={`${display ?? ""}`}>{t(tabName)} {isEditingHandler && display && (
                  <Button style={{maxWidth:'50px'}} onClick={() => isEditingHandler(currentData, udpateView)}>
                    <GetIcon icon={"edit"}></GetIcon>
                  </Button>
                )} </TabHead>
              <Form className={`vertical sub ${formMode}`}>
                {noGroups.map((attribute, index) => {
                  // try {
                    console.log(attribute,currentData?.[attribute.name]);
                  const itemValue = attribute.collection?.length > 0 && attribute.showItem?.length > 0 
                        ? currentData?.[attribute.collection]?.[attribute.showItem] 
                        : currentData?.[attribute.name] ?? "--";

                    // console.log(itemValue,currentData[attribute.name]);
                    // console.log(currentData,itemValue,currentData[attribute.name]);
                    if (attribute.type === "invitation") {
                      return (
                        <Td key={index}>
                          <Title>{t(attribute.label)}</Title>
                          <DataItem>
                            {currentData["invitationSent"] ?? false ? (
                              <>
                                <span>
                                  {t("invitationSent")} <GetIcon icon="approved" />
                                </span>
                              </>
                            ) : (
                              <FormInput
                                onChange={() => {
                                  sendInvitation(currentData["_id"]);
                                }}
                                type="submit"
                                value={t("sendInvitation")}
                                disabled={currentData["email"] ? false : true}
                              ></FormInput>
                            )}
                          </DataItem>
                        </Td>
                      );
                    }

                    if (attribute.type === "title") {
                      return (
                        <Td className="bold" key={index}>
                          <Title className="bold">{t(attribute.title)}</Title>
                        </Td>
                      );
                    }

                    return (
                      <Td key={index}>
                        <Title>{t(attribute.label)}</Title>
                        <DataItem>{(!(attribute.showItem) && typeof itemValue ==="object") ? objectValueReturn(currentData,attribute) : GetValue(attribute, itemValue, true)} </DataItem>
                      </Td>
                    );
                  // } catch (error) {
                  //   return (
                  //     <Td key={index}>
                  //       <Title>{t(attribute.label)}</Title>
                  //       <DataItem>{`--`} </DataItem>
                  //     </Td>
                  //   );
                  // }
                })}
              </Form>
            </Tab>
            {currentData && currentData?._id && actions?.map((item) => {
              return (
                item.type === "subList" &&
                item.element === "button" && (
                  <Tab className="sub" key={`sub-new-${item?.title}`} active={activeTab === item?.title}>
                    <ListTable setMessage={setMessage} setLoaderBox={setLoaderBox} referenceId={currentData?._id} attributes={item.attributes} {...item.params} shortName={item?.title} listHeadClass={"static"} viewDetails={viewDetails}></ListTable>
                  </Tab>
                )
              );
            })}
          </TabItems>

          {hasFiles && <ViewFiles customClass="large" page={{data: currentData}} setLoaderBox={setLoaderBox} title={"attendanceToday"} popup={false}></ViewFiles>}
        </TabContainer>
      )}
    </TrBody>
  );
};
const Popup = ({ formMode, viewMode, themeColors, openData, setLoaderBox, setMessage, closeModal, itemTitle , actionButton,actionFunction}) => {
  const [t] = useTranslation();
  const titleValue = (itemTitle.collection?.length > 0 ? openData?.data?.[itemTitle.collection]?.[itemTitle.name] ?? "" : openData?.data?.[itemTitle.name]) || "Please update the itemTitle.";
  console.log("Mesage1", setMessage);
  const tabHandler = useCallback(() => {
    const tempTab = openData.actions
      .filter((item) => item.type === "subList" || item.type === "subItem")
      .map((item, index) => ({
        name: `${item.id}-${index}`,
        title: item?.title,
        element: <ListTable viewMode={item.type ?? "subList"} setMessage={setMessage} setLoaderBox={setLoaderBox} parentReference={item?.params?.parentReference} referenceId={openData?.data?._id} attributes={item.attributes} {...item.params}></ListTable>,
      }));
    tempTab.unshift({
      name: `information-${titleValue}`,
      title: "Informations",
      element: (
        <TabContainer>
          <Head>
            <DataHead>
              <GetIcon icon={""}></GetIcon>
              <span>Basic Details</span>
            </DataHead>
          </Head>
          <DisplayInformations setMessage={setMessage} setLoaderBox={setLoaderBox} formMode={formMode} attributes={openData.attributes} data={openData.data} />
        </TabContainer>
      ),
    });
    setTabs(tempTab);
  }, [setMessage, setLoaderBox, openData, formMode, titleValue]);

  const [tabs, setTabs] = useState([]);
  console.log("Tabs", tabs);
  useEffect(() => {
    tabHandler();
  }, [tabHandler]);

  return (
    <Overlay>
      <Page className={`${openData?.item?.params?.customClass ?? "medium"} popup-child sub-page`}>
        <Header>
          <span>{`${GetValue(itemTitle, titleValue)}`}</span>
          <CloseButton theme={themeColors} onClick={closeModal}>
            <GetIcon icon={"Close"} />
          </CloseButton>
        </Header>
        <RowContainer theme={themeColors} className="popup-data">
          {tabs.length > 0 && <Tabs tabs={tabs}></Tabs>}
        </RowContainer>
      </Page>
    </Overlay>
  );
};
export default Popup;
